import React, { useState } from "react";
import { Button, Icon, Text } from "@telia/teddy";

interface Props {
    content?: string;
}

const SubscriptionTerms: React.FC<Props> = ({ content }) => {
    const [isTermsVisible, setTermsVisible] = useState(false);

    const toggleTerms = () => {
        setTermsVisible(!isTermsVisible);
    };

    if (!content) return null;

    return (
        <div>
            <Button variant="text" onClick={toggleTerms} size="sm">
                Abonnementsvilkår
                <Icon name={isTermsVisible ? "chevron-up" : "chevron-down"} aria-hidden="true" focusable="false" />
            </Button>

            {isTermsVisible && (
                <div>
                    <Text variant="paragraph-100">
                        <span dangerouslySetInnerHTML={{ __html: content }} />
                    </Text>
                </div>
            )}
        </div>
    );
};

export default SubscriptionTerms;
